import type { Maybe, PropertiesNullable } from '@@types/helpers'
import EntityBase from '@app/entities/EntityBase'
import type { IEntityListable } from '@app/entities/types'
import type {
  IDataRowGeneric,
  IWidgetListColumns
} from '@app/stores/helpers/StoreWidgetList/types'
import type {
  HealthCheckDomainStatus,
  HealthCheckStatus
} from '@server/graphql/typeDefs/types'

export default class EntityHealthCheckDomainStatus
  extends EntityBase
  implements
    PropertiesNullable<HealthCheckDomainStatus>,
    IEntityListable<IDataRowGeneric>
{
  healthCheckName: Maybe<string> = null
  directoryId: Maybe<number> = null
  status: Maybe<HealthCheckStatus> = null
  lastCheckDate: Maybe<string> = null
  statusSince: Maybe<string> = null

  constructor(data: Partial<HealthCheckDomainStatus>) {
    super()
    Object.assign(this, data)
  }

  /**
   * Not used, columns are hardcoded in the view with a custom render.
   */
  getColumns(): Array<IWidgetListColumns<IDataRowGeneric>> {
    return []
  }
}
